import { DomSanitizer } from '@angular/platform-browser';
import { PipeTransform, Pipe } from "@angular/core";

@Pipe({ name: 'minValue', standalone: true })
export class MinValuePipe implements PipeTransform {
    constructor(private sanitized: DomSanitizer) { }
    transform(value: number): number {
        return Number.MIN_SAFE_INTEGER;
    }
}